import { __ } from '@wordpress/i18n';

export const generalStyleTabs = [
	{ name: 'general', title: __('General', 'textdomain') },
	{ name: 'style', title: __('Style', 'textdomain') }
];

export const ThemeOptions = [
	{ label: 'Default', value: 'theme1' },
	{ label: 'Style 1', value: 'theme2' },
]